import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Clock } from "lucide-react";
import api from "@/lib/api";

export const TrialBadge = () => {
  const [info, setInfo] = useState(null);
  const nav = useNavigate();

  useEffect(() => {
    api.get("/billing/trial-status").then(({ data }) => setInfo(data)).catch(() => {});
  }, []);

  if (!info || info.plan !== "starter" || info.trial_days_left === null) return null;
  const expired = info.trial_days_left <= 0;
  return (
    <button onClick={() => nav("/pricing")}
      title={expired ? "Your free trial has ended — see plans that fit" : `Your Starter trial ends ${info.trial_ends}. See plans anytime — no pressure.`}
      className={`hidden sm:inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-[11px] font-bold border transition-colors ${expired ? "border-amber-400/60 text-amber-600 hover:bg-amber-500/10" : "border-primary/40 text-primary hover:bg-primary/10"}`}
      data-testid="trial-badge">
      <Clock className="h-3 w-3" />
      {expired ? "Trial ended · See plans" : `Trial · ${info.trial_days_left} day${info.trial_days_left === 1 ? "" : "s"} left`}
    </button>
  );
};
